import {useEffect, useState} from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useLanguageSwitcher } from "../hooks/useLanguageSwitcher";
import { getFlagEmoji } from "../utils/flagUtils";

export default function LanguageSwitcher({ lang, currentKey, sx }) {
    const { switchLanguage } = useLanguageSwitcher();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const languages = [
        { code: "it", flag: getFlagEmoji("it") },
        { code: "en", flag: getFlagEmoji("gb") },
    ];

    const currentLang = languages.find((l) => l.code === lang) || languages[0];

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    useEffect(() => {
        switchLanguage(lang, currentKey);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Button
                onClick={handleClick}
                endIcon={<ArrowDropDownIcon />}
                sx={{ fontSize: "1.3rem", minWidth: "auto", ...sx }}
            >
                {currentLang.flag}
            </Button>

            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                {languages
                    .filter((l) => l.code !== lang)
                    .map((l) => (
                        <MenuItem
                            key={l.code}
                            onClick={() => {
                                switchLanguage(l.code, currentKey);
                                handleClose();
                            }}
                            sx={{ fontSize: "1.3rem" }}
                        >
                            {l.flag}
                        </MenuItem>
                    ))}
            </Menu>
        </>
    );
}